import React, { Component } from 'react';
import {} from 'semantic-ui-react';
import { Form, Input } from 'formik-semantic-ui';
import { PhoneInput } from '../custom/PhoneInput';

class PublicContact extends Component {
  render() {
    return (
      <Form.Children>
        <Input
          inputProps={{
            icon: 'address book',
            iconPosition: 'left',
            placeholder: 'Contact Name'
          }}
          label="Contact Name"
          name="namePublic"
        />
        <Form.Group>
          <Input
            width={6}
            inputProps={{
              icon: 'mail',
              iconPosition: 'left',
              placeholder: 'Email '
            }}
            label="Email"
            name="emailPublic"
          />
          <PhoneInput
            width={6}
            name="phonePublic"
            label="Telephone no."
            setFieldValue={this.props.setFieldValue}
          />
        </Form.Group>
      </Form.Children>
    );
  }
}

export { PublicContact };
